@if (palette.open()) {
  <div class="cmdk-overlay" role="presentation" (click)="onOverlayClick($event)" (keydown)="$event.stopPropagation()">
    <div class="cmdk-panel" role="dialog" aria-modal="true" aria-label="Command palette">
      <div class="cmdk-search">
        <app-icon name="search" [size]="16" aria-hidden="true" />
        <input
          #searchInput
          type="text"
          class="cmdk-input"
          placeholder="Jump to anywhere or type a command…"
          [ngModel]="palette.query()"
          (ngModelChange)="onQueryChange($event)"
          aria-label="Search commands"
          autocomplete="off"
          spellcheck="false"
        />
        <kbd class="cmdk-kbd">esc</kbd>
      </div>

      <div class="cmdk-results" role="listbox">
        @if (groups().length === 0) {
          <div class="cmdk-empty">No matches for "{{ palette.query() }}"</div>
        }
        @for (g of groups(); track g.group) {
          <div class="cmdk-group">
            <div class="cmdk-group-label">{{ g.group }}</div>
            @for (cmd of g.commands; track cmd.id) {
              <button
                type="button"
                class="cmdk-item"
                [class.cmdk-item--active]="isHighlighted(cmd)"
                role="option"
                [attr.aria-selected]="isHighlighted(cmd)"
                (click)="activate(cmd)"
                (mouseenter)="$event.preventDefault()"
              >
                @if (cmd.icon) {
                  <app-icon [name]="cmd.icon" [size]="16" aria-hidden="true" />
                }
                <span class="cmdk-label">{{ cmd.label }}</span>
                @if (cmd.hint) {
                  <span class="cmdk-hint">{{ cmd.hint }}</span>
                }
              </button>
            }
          </div>
        }
      </div>
    </div>
  </div>
}
